const theno1plug = {
    id: 'theno1plug',
    publicSiteName: 'The No1 Plug',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#121212',
            secondary: '#fdec00',
            color1: '#e6d819',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '16px',
        header: {
            layout: 'minimal',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/theno1plug/favicon.ico',
        logo: '/theno1plug/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default theno1plug